import React from "react";
import * as S from './StarRatingMmtStyles'
import { WHITE_STAR_URL } from "../../../../../config/constants";

const StarRatingMmt = ({
  value
}) => {
  return (
    <S.StarRating>
      <S.Rating>{value}</S.Rating>
      <S.StarContainer>
        <S.StarImg src={WHITE_STAR_URL} alt="star" />
      </S.StarContainer>
    </S.StarRating>
  );
};

export default StarRatingMmt;